import Form from '../../../../../../components/form';
import request from '../../../../../../utils/request';
import ModalList from './components/modal_list.vue';
import awardList from './components/awardList';
import ImgList from './components/img_list.vue';

formCreate.component('ModalList', ModalList);
formCreate.component('awardList', awardList);
formCreate.component('ImgList', ImgList);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'hx_form',
      formParentCode: 'CRM20251022000000002',
      fields: [
        'executeCode',
        'banquetCode',
        'banquetName',
        'banquetType',
        'terminalCode',
        'terminalName',
        'banquetProductCode',
        'banquetProductName',
        'banquetTime',
        'applyBottleNum',
        'applyTableNum',
        'executeTableNum',
        'executeUserCode',
        'executeUserName',
        'companyCode',
        'companyName',
        'takeUserPhone',
        'takeUserName',
        'takeTime',
        'isQualified',
        'executeFileList',
        'consumerName',
        'consumerPhone',
      ],
    };
  },
  methods: {

    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'dealerName') {
        v.props = {
          ...v.props,
          params: {
            functionCode: 'customerList',
            paramData: {
              enableStatus: '009',
              terminalCode: this.formConfig.row.terminalCode,
            },
          },
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
          autosize: { minRows: 1, maxRows: 6 },
        };
        v.on = {
          ...v.on,
          change: (e) => {
            console.log('dealerName change', e);
            this.setValue({
              dealerName: e[0].customerName || '',
              dealerCode: e[0].customerCode || '',
            });
          },
        };
      }
      if (v.field === 'configFiles') {
        v.props = {
          ...v.props,
          fileMsg: '请上传: pdf,docx,xlsx,ppt,png,jpg等类型，且不超过100M',
        };
      }

      return v;
    },
    // 表单渲染完成后回调
    formComplete() {
      console.log('this.formConfig----', this.formConfig);
      this.disabled(true, this.fields);
      if (this.formConfig.code === 'fqhx' || this.formConfig.code === 'view') {
        request
          .post('/cps/v1/handleBanquetReward/banquetAuditDetail', {
            id: this.formConfig.row.id || '',
          })
          .then((res) => {
            if (res.success) {
              const { result } = res;
              this.setValue({
                ...result,
              });
            }
          });
      }
    },
    // 提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      console.log('formData____', formData);
      if (formData) {
        const url = '/cps/v1/handleBanquetReward/banquetAudit';
        const params = {
          id: this.formConfig.row.id,
          executeCode: formData.executeCode || '',
          dealerCode: formData.dealerCode,
          dealerName: formData.dealerName,
          auditFiles: formData.auditFiles,
          companySubjectCode: formData.companySubjectCode,
        };
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
